import { proxy } from 'valtio';

import type { ProfileFormState } from './schema';

export const initialProfileFormState = () =>
  ({
    fields: {
      displayName: null,
      bio: null,
      avatarUploadKey: null,
      coverImageUploadKey: null,
      spotifyUrl: null,
      tiktokUrl: null,
      delegateWallet: null,
      invitedByUserId: null,
    },
    errors: {
      displayName: null,
      bio: null,
      avatarUploadKey: null,
      coverImageUploadKey: null,
      spotifyUrl: null,
      tiktokUrl: null,
      delegateWallet: null,
    },
    loading: {
      avatarUploadKey: false,
      coverImageUploadKey: false,
    },
  }) satisfies ProfileFormState;

export const profileFormState: ProfileFormState = proxy(initialProfileFormState());

export type ProfileFormStateFields = keyof ProfileFormState['fields'];
export type ProfileFormErrors = keyof ProfileFormState['errors'];
